import { ComboBox } from "@progress/kendo-react-dropdowns";

function GroupCell({ dataItem, groups, hidden, onGroupChange }) {
    function handleGroupChange(event) {
        onGroupChange(
            event,
            dataItem
        );
    };

    if (dataItem.selected) {
        return (
            <td>
                <ComboBox
                    disabled={dataItem.hidden}
                    data={groups}
                    value={dataItem.group}
                    onChange={handleGroupChange}
                    allowCustom={true}
                    className="form-control-custom"
                />
            </td>
        );
    }

    return (
        <td>
            <span className={hidden ? "text-muted" : ""}>
                {dataItem.group}
            </span>
        </td>
    );
}

export default GroupCell;